import React from 'react';
import Typography from '@mui/material/Typography';
import { Overlay } from '../../../../components/DataGridVirtual';
import AddBusinessOutlinedIcon from '@mui/icons-material/AddBusinessOutlined';

export const NoRowsOverlay = ({
  defaultText,
  defaultTitle,
  error,
  filterCondition,
  helperText,
  noRecords,
}: {
  defaultText: string;
  defaultTitle: string;
  error?: boolean;
  filterCondition?: number | false;
  helperText?: string;
  noRecords?: string;
}) => {
  if (filterCondition) {
    return (
      <Overlay>
        <Typography
          sx={(theme) => ({
            color: theme.palette.error[600],
          })}
        >
          {noRecords}
        </Typography>
      </Overlay>
    );
  }

  if (error && helperText) {
    return (
      <Overlay>
        <Typography sx={(theme) => ({ color: theme.palette.error[600] })}>
          {helperText}
        </Typography>
      </Overlay>
    );
  }

  return (
    <Overlay
      icon={<AddBusinessOutlinedIcon />}
      text={defaultText}
      title={defaultTitle}
    />
  );
};
